import React from 'react';

import { FormContainer } from '@eika-kortbetjening/form-container';

import fallbackDictionary from './fallbackDictionary';
import Footer from './footer/Footer';
import Form from './form/Form';
import { Piwik, ReorderInfo, SiteCoreDictionary } from './types';

import './BlockFormSelectOrderCard.scss';

interface BlockFormSelectReasonForHardBlockProps {
    /** Selected reorder form error */
    selectedReorderError?: string | undefined;
    /** Function for the next button */
    next: () => void;
    /** Function for the cancel button */
    cancel: () => void;
    /** Optional information for reorder option */
    reorderInfo?: ReorderInfo;
    /** Information if the user is high fraud risk */
    userIsHighFraudRisk?: boolean;
    /** Sitecore dictionary */
    sitecoreDictionary?: SiteCoreDictionary;
    /** PIWIK tags */
    priceListUrl?: string | undefined;
    piwik?: Piwik;
}

const BlockFormSelectOrderCard = ({
    reorderInfo,
    selectedReorderError,
    userIsHighFraudRisk,
    next,
    cancel,
    sitecoreDictionary,
    piwik,
    priceListUrl,
}: BlockFormSelectReasonForHardBlockProps): JSX.Element => {
    const dictionary = { ...fallbackDictionary, ...sitecoreDictionary };

    return (
        <FormContainer
            data-track-id={piwik?.blockCardForm?.blockFormSelectOrderCardForm?.dataTrackId}
            data-track-linkname={piwik?.blockCardForm?.blockFormSelectOrderCardForm?.dataTrackLinkname}
            id={piwik?.blockCardForm?.blockFormSelectOrderCardForm?.dataTrackId}
        >
            <FormContainer.Header description={dictionary.blockStep2Legend} title={dictionary.blockReplaceTitle} />
            <FormContainer.Content>
                <Form
                    selectedReorderError={selectedReorderError}
                    reorderInfo={reorderInfo}
                    dictionary={dictionary}
                    userIsHighFraudRisk={userIsHighFraudRisk}
                    priceListUrl={priceListUrl}
                />
            </FormContainer.Content>
            <FormContainer.Footer>
                <Footer next={next} cancel={cancel} dictionary={dictionary} piwik={piwik} />
            </FormContainer.Footer>
        </FormContainer>
    );
};

export default BlockFormSelectOrderCard;
